module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10274.07d906aa.jpg";